import React from 'react';
import { urlWebsite } from 'src/config';
import { useLoading } from 'src/hooks/LoadingHook';
import { useModal } from "src/hooks/Modal"
import { useToast } from 'src/hooks/Toast';
import api from 'src/services/api';

export default function useIsention () {
const {addModal, removeModal} = useModal();
const {addLoading,removeLoading} = useLoading();
const {addToast} = useToast();

const sendIsention = async (data ) => {


addLoading({title: 'Transferindo...', key:'loading'});

let x = 0;

while(x < data?.length){

    const item = data[x];
await api.post(`/isention-recurse`,  item);

x += 1;

}
removeLoading('loading');
removeModal('modal')
addToast({title: 'Transferidos com sucesso', type:'success'})

}

    const prepareIsention = async (projectHash) => {
addLoading({title: 'Carregando...', key:'loading'});
const sales  = await api.get(`/list-sale-isentions/${projectHash}`  );

const IDs : Record<string,any> = [];

sales?.data?.rows?.map( item => {

    IDs?.push({_id: item?.client_id});

})

 
const isentionRecurses  = await api.get(`/isention-recurse`, {params: { limitItems: 1000, where : { project_id: projectHash    } }});

const list : Record<string,any> = [];

sales?.data?.rows?.map(sale => {

    
    const findIsention = isentionRecurses?.data?.rows?.find( i => i?.client_id === sale?.client_id);

    if(!findIsention){

        list.push({
            project_id: projectHash,
            product: sale?.product_id_response?.title,
            hash: sale?.sale_hash,
            client_id: sale?.client_id_response?._id?.toString(),
            name: sale?.client_id_response?.name,
            email: sale?.client_id_response?.email,
             phone: sale?.client_id_response?.phone,
            document_number: sale?.client_id_response?.document_number,
            category: sale?.category,
            area: sale?.area,
            subarea: sale?.subarea,
            document: sale?.fields?.isencao_upload,
            recurse_send_at: sale?.createdAt,
            isencao: sale?.fields?.isencao,
            status: 'Aguardando avaliação'
            

        })


    }

})
removeLoading('loading')

addModal({title: '', theme: 'whiteModal', key:'modal', content: <div className="column gap-xs full-width">

<button className='defaultButtonMini' onClick={() => sendIsention(list)}>Transferir</button>

<p>Somente serão listadas solicitações de isenção não transferidas para a aba de isenção.</p>
<table className='tableRef'>

    <tbody>
        <tr>
            <td>PROJETO</td>
        <td>PRODUTO</td>
         <td>PROTOCOLO</td>
         <td>ID DO CLIENTE</td>
        <td>NOME</td>
           <td>E-MAIL</td>
            <td>TELEFONE</td>
             <td>CPF</td>
                <td>UPLOAD</td>
        <td>CATEGORIA</td>
        <td>ÁREA</td>
        <td>SUBÁREA</td>
             <td>ACEITE</td>
        </tr>

        {list?.map( item => {


            return <tr>
                <td>{item?.project_id}</td>
                  <td>{item?.product}</td>
<td>{item?.hash}</td>
<td>{item?.client_id}</td>
<td>{item?.name}</td>
<td>{item?.email}</td>
<td>{item?.phone}</td>
<td>{item?.document_number}</td>
<td><a href={`${urlWebsite}/${item?.document}`} target='_BLANK'>Doc</a></td>
<td>{item?.category}</td>
<td>{item?.area}</td>
<td>{item?.subarea}</td>
   <td>{item?.isencao}</td>
                
            </tr>

        })}
    </tbody>
</table>


</div>})

    }


    return {prepareIsention, sendIsention}
}